import React from 'react'
import { MDXRenderer } from 'gatsby-plugin-mdx'
import { MDXProvider } from '@theme-ui/mdx'
import components from '@components/Mdx'
import MuxPlayer from '@mux/mux-player-react/lazy'
import AdSense from 'react-adsense'
import { SlAds } from './sl-ads'

const ArticleAds = (props) => {
  return (
    <AdSense.Google
      client='ca-pub-9608706048656906'
      slot='9031528274'
      style={{ display: 'block', margin: '2em 0' }}
      layout='in-article'
      format='fluid'
    />
  )
}

export const PostBody = ({ body }) => {
  return (
    <MDXProvider
      components={{
        ...components,
        MuxPlayer,
        ArticleAds,
        SlAds,
      }}
    >
      <MDXRenderer>{body}</MDXRenderer>
    </MDXProvider>
  )
}
